import React, {useEffect, useState} from 'react'
import FetchUtil from "../../../../util/FetchUtil";
import ConfigUtil from "../../../../util/ConfigUtil";

// Farbe der ersten drei Plätze, wie im Podium der Übersicht
const PODIUM = {1: "gold", 2: "silber", 3: "bronze"};

/**
 * Platzierungen des Events im neuen Design. Die alte Ansicht verwendet weiterhin PublicTournamentPlatzierungTab.
 * Gesucht wird über die Spielersuche der Seite, daher gibt es hier kein eigenes Suchfeld.
 */
export default function PlatzierungBereich({tournamentId}) {

    const [platzierungen, setPlatzierungen] = useState(undefined);
    const [fehler, setFehler] = useState(undefined);

    useEffect(() => {
        setFehler(undefined);
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.public + "/tournament/platzierung/" + tournamentId,
            {},
            json => setPlatzierungen(json),
            responseNotOk => setFehler(responseNotOk.message),
            error => setFehler(error.message));
    }, [tournamentId]);

    if (fehler !== undefined) {
        return <div className="dhpt-statistik"><p className="dhpt-hinweis" role="alert">Die Platzierungen konnten nicht geladen werden: {fehler}</p></div>
    }
    if (platzierungen === undefined) {
        return <div className="dhpt-statistik"><p className="dhpt-hinweis"><i className="pi pi-spin pi-spinner" aria-hidden="true"/> Platzierungen werden geladen …</p></div>
    }
    if (platzierungen.length === 0) {
        return <div className="dhpt-statistik"><p className="dhpt-hinweis">Es sind noch keine Platzierungen vorhanden.</p></div>
    }

    return <div className="dhpt-statistik">
        <div className="dhpt-st-rahmen dhpt-tab-schmal">
            <table className="dhpt-tab">
                <caption className="dhpt-st-versteckt">Platzierungen</caption>
                <thead>
                <tr>
                    <th scope="col" className="dhpt-tab-platz">Platz</th>
                    <th scope="col">Name</th>
                </tr>
                </thead>
                <tbody>
                {platzierungen.map(platzierung =>
                    <tr key={platzierung.idShort || platzierung.playerId} className="dhpt-tab-zeile">
                        <td className="dhpt-tab-platz"><Platz platz={platzierung.platz}/></td>
                        <td className="dhpt-tab-name">{platzierung.name}</td>
                    </tr>
                )}
                </tbody>
            </table>
        </div>
    </div>
}

export function Platz({platz}) {
    const farbe = PODIUM[platz];
    if (farbe === undefined) {
        return <span className="dhpt-tab-platz-zahl">{platz}.</span>
    }
    return <span className={"dhpt-tab-medaille dhpt-tab-medaille-" + farbe} aria-label={platz + ". Platz"}>{platz}</span>
}
